module.exports = "<section class=\"news-single col-xs-12 col-xs-offset-0 col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3\">\r\n    <div class=\"news-posts\">\r\n        <div class=\"news-post\" *ngIf=\"post\">\r\n            <p><span class=\"news-post-title\">{{ post.title }}</span><span class=\"news-post-divider\"></span><span class=\"news-post-content\" [innerHTML]=\"post.content | safeHtml\"></span><span class=\"news-post-date\">{{ post.date }}</span></p>\r\n        </div>\r\n    </div>\r\n</section>\r\n"


//////////////////
// WEBPACK FOOTER
// E:/MBP/BloomyNG/src/app/newspost/newspost.component.html
// module id = ../../../../../src/app/newspost/newspost.component.html
// module chunks = main